import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@repo/design-system/components/ui/collapsible';
import { cn } from '@repo/design-system/lib/utils';
import { ChevronDownIcon, MapPinIcon } from 'lucide-react';
import { useState } from 'react';

interface AdditionalInsuredsProps {
  insureds: {
    title: string;
    items: Array<{
      name: string;
      address: string;
      isCertificateHolder?: boolean;
    }>;
  };
  spacing?: 'narrow' | 'wide';
}

export function AdditionalInsureds({
  insureds,
  spacing = 'narrow',
}: AdditionalInsuredsProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className="space-y-4 pt-6"
    >
      <CollapsibleTrigger className="flex w-full items-center justify-between">
        <h4 className="font-medium text-base">{insureds.title}</h4>
        <ChevronDownIcon
          className={cn(
            'h-4 w-4 transition-transform',
            isOpen ? 'rotate-180' : ''
          )}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className={`space-y-${spacing === 'wide' ? '3' : '2'} text-sm`}>
          {insureds.items.map((item, index) => (
            <div
              key={index}
              className={`grid grid-cols-[auto_1fr] items-start ${spacing === 'wide' ? 'gap-2' : 'gap-1.5'}`}
            >
              <MapPinIcon className="mt-0.5 h-3 w-3 text-muted-foreground" />
              <div>
                <b>{item.name}</b> {item.address}
                {item.isCertificateHolder && (
                  <span className="ml-1 rounded bg-blue-100 px-1 py-0.5 text-blue-700 text-xs dark:bg-blue-900/40 dark:text-blue-300">
                    Certificate holder
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
